import formRules from './form-rules.json';

export default {
  shared: {
    ...formRules,
  },
};
